var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7137 23.4251L38.438 17.1494V9.89994C38.438 8.58913 37.3758 7.52683 36.063 7.52683C34.7533 7.52683 33.6911 8.58913 33.6911 9.89994V12.4026L29.0183 7.7297C26.7081 5.42069 22.6913 5.42479 20.3863 7.73387L4.69473 23.4251C3.76842 24.3533 3.76842 25.8551 4.69473 26.7818C5.62146 27.7097 7.12619 27.7097 8.05258 26.7818L23.7427 11.0901C24.2538 10.5817 25.1547 10.5817 25.6632 11.0886L41.3559 26.7818C41.8212 27.2458 42.4279 27.4766 43.0344 27.4766C43.6422 27.4766 44.2499 27.2455 44.7138 26.7818C45.6404 25.8552 45.6404 24.3534 44.7137 23.4251Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5285 15.5949C25.0726 15.1392 24.3344 15.1392 23.8799 15.5949L10.0775 29.3931C9.85963 29.611 9.73608 29.9084 9.73608 30.2187V40.2827C9.73608 42.6442 11.6509 44.559 14.0124 44.559H20.8459V33.976H28.5609V44.559H35.3946C37.756 44.559 39.6708 42.6442 39.6708 40.2827V30.2187C39.6708 29.9084 39.5483 29.611 39.3293 29.3931L25.5285 15.5949Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.aecb8096.svg";
export { ForwardRef as ReactComponent };